import { Component } from '@angular/core';

@Component({
  selector: 'app-approval-status-progressbar',
  templateUrl: './approval-status-progressbar.component.html',
  styleUrls: ['./approval-status-progressbar.component.scss']
})
export class ApprovalStatusProgressbarComponent {

}
